import get from 'lodash/get'
import globalComponents from '../util/globalComponentsRequire'
import '../assets/scss/main.scss'
import AppNotifyService from '@/util/AppNotifyService.js'

export default {
    install (app) {
        app.use(globalComponents)
        app.use(AppNotifyService)
        app.config.globalProperties.get = get
    },
}
